import React, { useState, useEffect, useCallback } from "react";
import api from "./../../api.js";
import Dashheader from "../Dashboard/Dashheader/Dashheader.jsx";
import './consolatedreport.css';

const Consalatedreport = () => {
    const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');

    const [customerlist, setCustomerList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [view, setView] = useState('table');
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('table');
    const [sortConfig, setSortConfig] = useState({ key: 'totalAmount', direction: 'desc' });

    // const fetchCustomerList = useCallback(async () => {
    //     setLoading(true);
    //     try {
    //         let response = await api.getConsolatedReport(searchTerm);
    //         const result = Array.isArray(response?.data?.data) ? response.data.data : [];
    //         setCustomerList(result);
    //     } catch (error) {
    //         console.error("Error fetching customer details:", error);
    //         setCustomerList([]);
    //     } finally {
    //         setLoading(false);
    //     }
    // }, [searchTerm]);

    const fetchCustomerList = useCallback(async () => {
    setLoading(true);
    try {
        let response = await api.getConsolatedReport(searchTerm, startDate, endDate);
        const result = Array.isArray(response?.data?.data) ? response.data.data : [];
        setCustomerList(result);
    } catch (error) {
        setCustomerList([]);
    } finally {
        setLoading(false);
    }
}, [searchTerm, startDate, endDate]);

    useEffect(() => {
        fetchCustomerList();
    }, [fetchCustomerList]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setView(tab);
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...customerlist].sort((a, b) => {
        const valA = a[sortConfig.key] || 0;
        const valB = b[sortConfig.key] || 0;
        if (valA < valB) {
            return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (valA > valB) {
            return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
    });

    const filteredData = sortedData;

    const totalSum = filteredData.reduce((sum, item) => sum + (item.totalAmount || 0), 0);
    const totalGst = filteredData.reduce((sum, item) => sum + (item.totalPaidGstAmount || 0), 0);
    const totalPayable = filteredData.reduce((sum, item) => sum + (item.totalPayableAmount || 0), 0);
    const totalWithoutGst = filteredData.reduce((sum, item) => sum + (item.totalPaidWithoutGst || 0), 0);
    // --- Add this to your existing calculations ---
    const totalTds = filteredData.reduce((sum, item) => sum + (item.totalTdsAmount || 0), 0);

    // Add these to your existing calculations
const totalCGST = filteredData.reduce((sum, item) => sum + (item.totalCGST || 0), 0);
const totalSGST = filteredData.reduce((sum, item) => sum + (item.totalSGST || 0), 0);
const totalIGST = filteredData.reduce((sum, item) => sum + (item.totalIGST || 0), 0);
const totalUGST = filteredData.reduce((sum, item) => sum + (item.totalUGST || 0), 0);


    const totalCash = filteredData.reduce((sum, item) => sum + (item.totalCashAmount || 0), 0);
    const totalNetbanking = filteredData.reduce((sum, item) => 
        sum + (item.totalChequeAmount || 0) + (item.totalBankTransferAmount || 0), 0
    );

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return '↕️';
        return sortConfig.direction === 'asc' ? '↑' : '↓';
    };

    const exportToCSV = () => {
const headers = [
    'Name', 'Email', 'Phone', 'pancard', 'Flat Value', 
    'Cash Amount', 'Netbanking Amount', 'CGST', 'SGST', 
    'IGST', 'UGST', 'Total GST', 'Total Received (Period)', 
    // 'Payable Amount',
    'Start Date', 'End Date' // Add this
];

      const data = filteredData.map(c => [
    `"${c.name}"`,
    `"${c.emailId}"`,
    c.phoneNumber,
    c.pancard || "NA",
    c.totalAmount,
    c.totalCashAmount || 0,
    (c.totalChequeAmount || 0) + (c.totalBankTransferAmount || 0),
    c.totalCGST || 0,
    c.totalSGST || 0,
    c.totalIGST || 0,
    c.totalUGST || 0,
    c.totalPaidGstAmount,
    (c.totalPaidWithoutGst || 0) + (c.totalPaidGstAmount || 0), 
    // c.totalPayableAmount,
    startDate || "NA", // Add this
    endDate || "NA"    // Add this
]);


        
        const csvContent = [
            headers.join(','),
            ...data.map(row => row.join(','))
        ].join('\n');
        
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
// Replace the old setAttribute line with this one
link.setAttribute('download', `consolidated_report_${startDate || 'all'}_to_${endDate || 'all'}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollButton = document.querySelector('.scroll-top-button');
            if (scrollButton) {
                if (window.pageYOffset > 300) {
                    scrollButton.classList.add('visible');
                } else {
                    scrollButton.classList.remove('visible');
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <Dashheader />
            <div className="consolatedreport-container">
                <div className="consolatedreport-header">
                    <h2 className="consolatedreport-title">Consolidated Report</h2>
                    <div className="consolatedreport-actions">
                        <button className="consolatedreport-export-btn" onClick={exportToCSV}>
                            <span className="icon">📊</span> Export CSV
                        </button>
                    </div>
                </div>

                <div className="date-filters" style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
    <input 
        type="date" 
        value={startDate} 
        onChange={(e) => setStartDate(e.target.value)} 
        className="consolatedreport-input" 
    />
    <input 
        type="date" 
        value={endDate} 
        onChange={(e) => setEndDate(e.target.value)} 
        className="consolatedreport-input" 
    />
    <button onClick={fetchCustomerList} className="consolatedreport-button">Filter</button>
</div>

               
                <div 
                    className="scroll-top-button" 
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                    ↑
                </div>


                <div className="summary-cards-container">
                    <div className="summary-card">
                        <div className="summary-card-icon">💰</div>
                        <div className="summary-card-content">
                            <h3>Total Amount</h3>
                            <div className="summary-amount">{formatCurrency(totalSum).replace('₹', '₹ ')}</div>
                        </div>
                    </div>

                    <div className="summary-card" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }}>
                        <div className="summary-card-icon">💵</div>
                        <div className="summary-card-content">
                            <h3>Total Cash</h3>
                            <div className="summary-amount">{formatCurrency(totalCash).replace('₹', '₹ ')}</div>
                        </div>
                    </div>

                    <div className="summary-card" style={{ background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)' }}>
    <div className="summary-card-icon">📝</div>
    <div className="summary-card-content">
        <h3>Total TDS</h3>
        <div className="summary-amount">{formatCurrency(totalTds).replace('₹', '₹ ')}</div>
    </div>
</div>


                    <div className="summary-card" style={{ background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' }}>
                        <div className="summary-card-icon">🌐</div>
                        <div className="summary-card-content">
                            <h3>Total Netbanking</h3>
                            <div className="summary-amount">{formatCurrency(totalNetbanking).replace('₹', '₹ ')}</div>
                        </div>
                    </div>

                    {/* Total Paid Without GST Card */}
                    <div className="summary-card" style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}>
                        <div className="summary-card-icon">📈</div>
                        <div className="summary-card-content">
                            <h3>Total Paid (Excl. GST)</h3>
                            <div className="summary-amount">{formatCurrency(totalWithoutGst).replace('₹', '₹ ')}</div>
                        </div>
                    </div>

                    <div className="summary-card" style={{ background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' }}>
                        <div className="summary-card-icon">🧾</div>
                        <div className="summary-card-content">
                            <h3>Total GST Amount</h3>
                            <div className="summary-amount">{formatCurrency(totalGst).replace('₹', '₹ ')}</div>
                        </div>
                    </div>

                    <div className="summary-card">
                        <div className="summary-card-icon">✅</div>
                        <div className="summary-card-content">
                            <h3>Total Received (Incl. GST)</h3>
                            <div className="summary-amount">
                                {formatCurrency(totalWithoutGst + totalGst).replace('₹', '₹ ')}
                            </div>
                        </div>
                    </div>
                    
                    <div className="summary-card">
                        <div className="summary-card-icon">👥</div>
                        <div className="summary-card-content">
                            <h3>Customer Count</h3>
                            <div className="summary-amount">{filteredData.length}</div>
                        </div>
                    </div>
                </div>

                <div className="consolatedreport-searchbar">
                    <input
                        type="text"
                        placeholder="Search by name, email or phone..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="consolatedreport-input"
                    />
                    <button onClick={fetchCustomerList} className="consolatedreport-button">
                        <span className="button-icon">🔍</span> Search
                    </button>
                </div>

                <div className="consolatedreport-toggle">
                    <button 
                        className={activeTab === 'table' ? 'active' : ''} 
                        onClick={() => handleTabChange('table')}
                    >
                        <span className="tab-icon">📋</span> Table View
                    </button>
                    <button 
                        className={activeTab === 'bar' ? 'active' : ''} 
                        onClick={() => handleTabChange('bar')}
                    >
                        <span className="tab-icon">📊</span> Bar Chart
                    </button>
                    <button 
                        className={activeTab === 'pie' ? 'active' : ''} 
                        onClick={() => handleTabChange('pie')}
                    >
                        <span className="tab-icon">🥧</span> Pie Chart
                    </button>
                </div>

                {loading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading data...</p>
                    </div>
                ) : filteredData.length > 0 ? (
                    <>
                        {view === 'table' && (
                            <table className="consolatedreport-table">
                                <thead>
                                    <tr>
                                        <th onClick={() => handleSort('name')}>
                                            Customer {getSortIcon('name')}
                                        </th>
                                        <th onClick={() => handleSort('phoneNumber')}>
                                            Phone {getSortIcon('phoneNumber')}
                                        </th>
                                        <th onClick={() => handleSort('totalAmount')}>
                                            Total Amount {getSortIcon('totalAmount')}
                                        </th>
                                        <th onClick={() => handleSort('totalCashAmount')}>
                                            Cash Mode {getSortIcon('totalCashAmount')}
                                        </th>
                                        <th>
                                            Netbanking (Cheque + Transfer)
                                        </th>
                                        <th onClick={() => handleSort('totalPaidGstAmount')}>
                                            GST {getSortIcon('totalPaidGstAmount')}
                                        </th>
                                        <th>
                                            Total Received (Incl. GST)
                                        </th>
                                        <th onClick={() => handleSort('totalPayableAmount')}>
                                            Receivable Amount {getSortIcon('totalPayableAmount')}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((c, idx) => (
                                        <tr key={c._id}>
                                            <td>
                                                <div className="customer-info">
                                                    <div className="customer-avatar">{idx + 1}</div>
                                                    <div className="customer-name">{c.name}</div>
                                                </div>
                                            </td>
                                            <td>{c.phoneNumber}</td>
                                            <td>
                                                <span className="amount-highlight">
                                                    {formatCurrency(c.totalAmount).replace('₹', '₹ ')}
                                                </span>
                                            </td>
                                            <td>{formatCurrency(c.totalCashAmount || 0).replace('₹', '₹ ')}</td>
                                            <td>{formatCurrency((c.totalChequeAmount || 0) + (c.totalBankTransferAmount || 0)).replace('₹', '₹ ')}</td>
                                            <td>{formatCurrency(c.totalPaidGstAmount).replace('₹', '₹ ')}</td>
                                            <td>
                                                <strong style={{ color: '#16a34a' }}>
                                                    {formatCurrency((c.totalPaidWithoutGst || 0) + (c.totalPaidGstAmount || 0)).replace('₹', '₹ ')}
                                                </strong>
                                            </td>
                                            <td>{formatCurrency(c.totalPayableAmount).replace('₹', '₹ ')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="2"><strong>Total</strong></td>
                                        <td><strong>{formatCurrency(totalSum).replace('₹', '₹ ')}</strong></td>
                                        <td><strong>{formatCurrency(totalCash).replace('₹', '₹ ')}</strong></td>
                                        <td><strong>{formatCurrency(totalNetbanking).replace('₹', '₹ ')}</strong></td>
                                        <td><strong>{formatCurrency(totalGst).replace('₹', '₹ ')}</strong></td>
                                        <td><strong>{formatCurrency(totalWithoutGst + totalGst).replace('₹', '₹ ')}</strong></td>
                                        <td><strong>{formatCurrency(totalPayable).replace('₹', '₹ ')}</strong></td>
                                    </tr>
                                </tfoot>
                            </table>
                        )}

                        {view === 'bar' && (
                            <div className="consolatedreport-bar-chart">
                                <div className="chart-header">
                                    <h3>Revenue Distribution</h3>
                                    <div className="chart-legend">
                                        <span className="legend-item">
                                            <span className="legend-color" style={{background: 'linear-gradient(90deg, #6366f1 0%, #4f46e5 100%)'}}></span>
                                            <span>Total Amount</span>
                                        </span>
                                        <span className="legend-item">
                                            <span className="legend-color" style={{background: 'linear-gradient(90deg, #22c55e 0%, #16a34a 100%)'}}></span>
                                            <span>Paid Amount</span>
                                        </span>
                                    </div>
                                </div>
                                <div style={{width: 300, margin: '0 auto', padding: 16}}>
                                    <svg width="220" height="220">
                                        <rect x="60" y="60" width="40" height="120" fill="#e5e7eb" rx="8" />
                                        <rect x="60" y={60 + 120 - 160 * (totalSum > 0 ? 1 : 0)} width="40" height={160 * (totalSum > 0 ? 1 : 0)} fill="#6366f1" rx="8" />
                                        <rect x="120" y="60" width="40" height="120" fill="#e5e7eb" rx="8" />
                                        <rect x="120" y={60 + 120 - 160 * (totalSum > 0 ? totalWithoutGst / totalSum : 0)} width="40" height={160 * (totalSum > 0 ? totalWithoutGst / totalSum : 0)} fill="#22c55e" rx="8" />
                                        <text x="80" y="200" textAnchor="middle" fontSize="14" fill="#222">Total</text>
                                        <text x="140" y="200" textAnchor="middle" fontSize="14" fill="#222">Paid</text>
                                        <text x="80" y={60 + 120 - 160 * (totalSum > 0 ? 1 : 0) - 8} textAnchor="middle" fontSize="12" fill="#6366f1">{formatCurrency(totalSum).replace('₹', '₹ ')}</text>
                                        <text x="140" y={60 + 120 - 160 * (totalSum > 0 ? totalWithoutGst / totalSum : 0) - 8} textAnchor="middle" fontSize="12" fill="#22c55e">{formatCurrency(totalWithoutGst).replace('₹', '₹ ')}</text>
                                    </svg>
                                </div>
                            </div>
                        )}

                        {view === 'pie' && (
                            <div className="consolatedreport-pie-container">
                                <div className="chart-header">
                                    <h3>Revenue Share</h3>
                                    <div className="chart-legend">
                                        <span className="legend-item">
                                            <span className="legend-color" style={{background: '#6366f1'}}></span>
                                            <span>Total Amount</span>
                                        </span>
                                        <span className="legend-item">
                                            <span className="legend-color" style={{background: '#22c55e'}}></span>
                                            <span>Paid Amount</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="consolatedreport-pie-chart" style={{position: 'relative', width: 320, height: 320, margin: '0 auto'}}>
                                    <svg width="320" height="320" viewBox="0 0 320 320">
                                        <circle cx="160" cy="160" r="120" fill="#e5e7eb" />
                                        <circle cx="160" cy="160" r="120" fill="none" stroke="#6366f1" strokeWidth="32" strokeDasharray={`${2 * Math.PI * 120}`} strokeDashoffset={0} style={{transition: 'stroke-dashoffset 0.5s'}} />
                                        <circle cx="160" cy="160" r="80" fill="#e5e7eb" />
                                        <circle cx="160" cy="160" r="80" fill="none" stroke="#22c55e" strokeWidth="32" strokeDasharray={`${2 * Math.PI * 80}`} strokeDashoffset={`${2 * Math.PI * 80 * (1 - (totalSum > 0 ? totalWithoutGst / totalSum : 0))}`} style={{transition: 'stroke-dashoffset 0.5s'}} />
                                    </svg>
                                    <div style={{position: 'absolute', top: 0, left: 0, width: 320, height: 320, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none'}}>
                                        <div style={{fontWeight: 600, fontSize: 18, color: '#222'}}>Total: {formatCurrency(totalSum).replace('₹', '₹ ')}</div>
                                        <div style={{fontWeight: 600, fontSize: 18, color: '#22c55e'}}>Paid: {formatCurrency(totalWithoutGst).replace('₹', '₹ ')}</div>
                                        <div style={{fontSize: 15, color: '#222'}}>Paid %: {totalSum > 0 ? ((totalWithoutGst / totalSum) * 100).toFixed(1) : 0}%</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="empty-state">
                        <div className="empty-icon">📊</div>
                        <h3>No customer data available</h3>
                        <p>Try adjusting your search or add new customers to see data here.</p>
                        <button 
                            className="consolatedreport-button-secondary" 
                            onClick={() => {
                                setSearchTerm('');
                                fetchCustomerList();
                            }}
                        >
                            Reset Search
                        </button>
                    </div>
                )}
                
                <div className="consolatedreport-footer">
                    <div className="footer-info">
                        <p>Showing {filteredData.length} of {customerlist.length} customers</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Consalatedreport;
